import React, { useState } from 'react';

function Contact() {
  const [form, setForm] = useState({
    name: '',
    email: '',
    company: '',
    message: '',
    website: ''
  });

  const [status, setStatus] = useState('idle');
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setForm((prev) => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    setError('');

    try {
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(form)
      });

      const data = await response.json();

      if (!response.ok || !data.ok) {
        throw new Error(data.error || 'Something went wrong.');
      }

      setStatus('success');
      setForm({
        name: '',
        email: '',
        company: '',
        message: '',
        website: ''
      });
    } catch (err) {
      setStatus('error');
      setError(err.message || 'Something went wrong.');
    }
  };

  return (
    <div style={{ minHeight: '100vh', padding: '2rem', textAlign: 'center' }}>
      <h1>Contact</h1>
      <p>
        If you have an enquiry or would like to discuss a potential collaboration,
        please get in touch.
      </p>

      <form
        onSubmit={handleSubmit}
        style={{
          maxWidth: '500px',
          margin: '2rem auto',
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem'
        }}
      >
        <input
          type="text"
          name="name"
          placeholder="Full name"
          value={form.name}
          onChange={handleChange}
          required
          style={{ padding: '0.8rem', fontSize: '1rem' }}
        />

        <input
          type="email"
          name="email"
          placeholder="Email address"
          value={form.email}
          onChange={handleChange}
          required
          style={{ padding: '0.8rem', fontSize: '1rem' }}
        />

        <input
          type="text"
          name="company"
          placeholder="Company (optional)"
          value={form.company}
          onChange={handleChange}
          style={{ padding: '0.8rem', fontSize: '1rem' }}
        />

        <textarea
          name="message"
          placeholder="Your message"
          value={form.message}
          onChange={handleChange}
          required
          rows="5"
          style={{ padding: '0.8rem', fontSize: '1rem' }}
        />

        <input
          type="text"
          name="website"
          value={form.website}
          onChange={handleChange}
          autoComplete="off"
          tabIndex="-1"
          style={{
            position: 'absolute',
            left: '-9999px',
            width: '1px',
            height: '1px',
            opacity: 0
          }}
          aria-hidden="true"
        />

        <button
          type="submit"
          disabled={status === 'sending'}
          style={{
            padding: '1rem',
            fontSize: '1rem',
            backgroundColor: '#000',
            color: '#fff',
            border: 'none',
            cursor: status === 'sending' ? 'default' : 'pointer',
            opacity: status === 'sending' ? 0.7 : 1
          }}
        >
          {status === 'sending' ? 'Sending...' : 'Send message'}
        </button>
      </form>

      {status === 'success' && (
        <p style={{ color: 'green' }}>
          Thank you — your message has been sent.
        </p>
      )}

      {status === 'error' && (
        <p style={{ color: 'red' }}>
          {error || 'Something went wrong. Please try again.'}
        </p>
      )}
    </div>
  );
}

export default Contact;